import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class SearchHistoryService {
  baseUrl: string = environment.baseUrl;

  constructor(private http: HttpClient) {}

  // IMAGE HISTORY
  getImageHistories(
    page: any,
    size: any,
    searchKey?: any,
    searchValue?: any,
    startDate?: any,
    endDate?: any,
  ): Observable<any> {
    // console.log(
    //   'GET IMAGE HISTORIES PARAMS: ',
    //   page,
    //   size,
    //   searchKey,
    //   searchValue,
    //   startDate,
    //   endDate,
    // );

    const url = `${this.baseUrl}/search/history`;
    let params = new HttpParams().set('page', page).set('size', size);

    if (searchKey) {
      params = params.set('search_key', searchKey);
    }

    if (searchValue) {
      params = params.set('search_value', searchValue);
    }

    if (startDate) {
      params = params.set('start_date', startDate);
    }

    if (endDate) {
      params = params.set('end_date', endDate);
    }

    return this.http.get<any>(url, { params });
  }

  deleteImageHistories(searchIds: any): Observable<any> {
    const url = `${this.baseUrl}/search/history`;
    const options = {
      body: { search_ids: searchIds },
    };

    return this.http.delete<any>(url, options);
  }

  // LINK ANALYSIS HISTORY
  getLinkAnalysisHistories(
    page: any,
    size: any,
    searchKey?: any,
    searchValue?: any,
    startDate?: any,
    endDate?: any,
  ): Observable<any> {
    const url = `${this.baseUrl}/link-analysis/history`;
    let params = new HttpParams().set('page', page).set('size', size);

    if (searchKey) {
      params = params.set('search_key', searchKey);
    }

    if (searchValue) {
      params = params.set('search_value', searchValue);
    }

    if (startDate) {
      params = params.set('start_date', startDate);
    }

    if (endDate) {
      params = params.set('end_date', endDate);
    }

    return this.http.get<any>(url, { params });
  }

  // OSINT HISTORY
  getOsintHistories(
    selectedOsintHistoryType: any,
    page: any,
    size: any,
    searchKey?: any,
    searchValue?: any,
    startDate?: any,
    endDate?: any,
    shouldExport?: any,
    exportFormat?: any,
  ): Observable<any> {
    // console.log(
    //   'GET OSINT HISTORIES PARAMS: ',
    //   selectedOsintHistoryType,
    //   page,
    //   size,
    //   searchKey,
    //   searchValue,
    //   startDate,
    //   endDate,
    //   shouldExport,
    //   exportFormat,
    // );

    const url = `${this.baseUrl}/osint/history`;
    let params = new HttpParams()
      .set('type', selectedOsintHistoryType)
      .set('page', page)
      .set('size', size);

    if (searchKey) {
      params = params.set('search_key', searchKey);
    }

    if (searchValue) {
      params = params.set('search_value', searchValue);
    }

    if (startDate) {
      params = params.set('start_date', startDate);
    }

    if (endDate) {
      params = params.set('end_date', endDate);
    }

    if (shouldExport) {
      params = params.set('is_export', shouldExport);
    }

    if (exportFormat) {
      params = params.set('format', exportFormat);
    }

    return this.http.get<any>(url, { params });
  }

  exportOsintHistories(
    selectedOsintHistoryType: any,
    page: any,
    size: any,
    searchKey?: any,
    searchValue?: any,
    startDate?: any,
    endDate?: any,
    shouldExport?: any,
    exportFormat?: any,
  ): Observable<any> {
    const url = `${this.baseUrl}/osint/history`;
    let params = new HttpParams()
      .set('type', selectedOsintHistoryType)
      .set('page', page)
      .set('size', size);

    if (searchKey) {
      params = params.set('search_key', searchKey);
    }

    if (searchValue) {
      params = params.set('search_value', searchValue);
    }

    if (startDate) {
      params = params.set('start_date', startDate);
    }

    if (endDate) {
      params = params.set('end_date', endDate);
    }

    if (shouldExport) {
      params = params.set('is_export', shouldExport);
    }

    if (exportFormat) {
      params = params.set('format', exportFormat);
    }

    return this.http.get<any>(url, { params });
  }

  deleteOsintHistories(searchIds: any): Observable<any> {
    const url = `${this.baseUrl}/osint`;
    const options = {
      body: { osint_search_ids: searchIds },
    };

    return this.http.delete<any>(url, options);
  }

  // LEAK HISTORY
  getLeakHistories(
    selectedLeakHistoryType: any,
    page: any,
    size: any,
    searchKey?: any,
    searchValue?: any,
    startDate?: any,
    endDate?: any,
    shouldExport?: any,
    exportFormat?: any,
  ): Observable<any> {
    // console.log(
    //   'GET LEAK HISTORIES PARAMS: ',
    //   selectedLeakHistoryType,
    //   page,
    //   size,
    //   searchKey,
    //   searchValue,
    //   startDate,
    //   endDate,
    //   shouldExport,
    //   exportFormat,
    // );

    const url = `${this.baseUrl}/leak/history`;
    let params = new HttpParams()
      .set('type', selectedLeakHistoryType)
      .set('page', page)
      .set('size', size);

    if (searchKey) {
      params = params.set('search_key', searchKey);
    }

    if (searchValue) {
      params = params.set('search_value', searchValue);
    }

    if (startDate) {
      params = params.set('start_date', startDate);
    }

    if (endDate) {
      params = params.set('end_date', endDate);
    }

    if (shouldExport) {
      params = params.set('is_export', shouldExport);
    }

    if (exportFormat) {
      params = params.set('format', exportFormat);
    }

    return this.http.get<any>(url, { params });
  }

  exportLeakHistories(
    selectedLeakHistoryType: any,
    page: any,
    size: any,
    searchKey?: any,
    searchValue?: any,
    startDate?: any,
    endDate?: any,
    shouldExport?: any,
    exportFormat?: any,
  ): Observable<any> {
    const url = `${this.baseUrl}/leak/history`;
    let params = new HttpParams()
      .set('type', selectedLeakHistoryType)
      .set('page', page)
      .set('size', size);

    if (searchKey) {
      params = params.set('search_key', searchKey);
    }

    if (searchValue) {
      params = params.set('search_value', searchValue);
    }

    if (startDate) {
      params = params.set('start_date', startDate);
    }

    if (endDate) {
      params = params.set('end_date', endDate);
    }

    if (shouldExport) {
      params = params.set('is_export', shouldExport);
    }

    if (exportFormat) {
      params = params.set('format', exportFormat);
    }

    return this.http.get<any>(url, { params });
  }

  deleteLeakHistories(searchIds: any): Observable<any> {
    const url = `${this.baseUrl}/leak/delete`;
    const options = {
      body: { leak_search_ids: searchIds },
    };

    return this.http.delete<any>(url, options);
  }

  // VEHICLE HISTORY
  getVehicleHistories(
    page: any,
    size: any,
    searchKey?: any,
    searchValue?: any,
    startDate?: any,
    endDate?: any,
    shouldExport?: any,
    exportFormat?: any,
  ): Observable<any> {
    const url = `${this.baseUrl}/vehicle/history`;
    let params = new HttpParams().set('page', page).set('size', size);

    if (searchKey) {
      params = params.set('search_key', searchKey);
    }

    if (searchValue) {
      params = params.set('search_value', searchValue);
    }

    if (startDate) {
      params = params.set('start_date', startDate);
    }

    if (endDate) {
      params = params.set('end_date', endDate);
    }

    if (shouldExport) {
      params = params.set('is_export', shouldExport);
    }

    if (exportFormat) {
      params = params.set('format', exportFormat);
    }

    return this.http.get<any>(url, { params });
  }

  exportVehicleHistories(
    page: any,
    size: any,
    searchKey?: any,
    searchValue?: any,
    startDate?: any,
    endDate?: any,
    shouldExport?: any,
    exportFormat?: any,
  ): Observable<any> {
    const url = `${this.baseUrl}/vehicle/history`;
    let params = new HttpParams().set('page', page).set('size', size);

    if (searchKey) {
      params = params.set('search_key', searchKey);
    }

    if (searchValue) {
      params = params.set('search_value', searchValue);
    }

    if (startDate) {
      params = params.set('start_date', startDate);
    }

    if (endDate) {
      params = params.set('end_date', endDate);
    }

    if (shouldExport) {
      params = params.set('is_export', shouldExport);
    }

    if (exportFormat) {
      params = params.set('format', exportFormat);
    }

    return this.http.get<any>(url, { params });
  }

  deleteVehicleHistories(searchIds: any): Observable<any> {
    const url = `${this.baseUrl}/vehicle/delete`;
    const options = {
      body: { vehicle_search_ids: searchIds },
    };

    return this.http.delete<any>(url, options);
  }

  // PAN HISTORY
  getPanHistories(
    page: any,
    size: any,
    searchKey?: any,
    searchValue?: any,
    startDate?: any,
    endDate?: any,
    shouldExport?: any,
    exportFormat?: any,
  ): Observable<any> {
    const url = `${this.baseUrl}/pan/history`;
    let params = new HttpParams().set('page', page).set('size', size);

    if (searchKey) {
      params = params.set('search_key', searchKey);
    }

    if (searchValue) {
      params = params.set('search_value', searchValue);
    }

    if (startDate) {
      params = params.set('start_date', startDate);
    }

    if (endDate) {
      params = params.set('end_date', endDate);
    }

    if (shouldExport) {
      params = params.set('is_export', shouldExport);
    }

    if (exportFormat) {
      params = params.set('format', exportFormat);
    }

    return this.http.get<any>(url, { params });
  }

  exportPanHistories(
    page: any,
    size: any,
    searchKey?: any,
    searchValue?: any,
    startDate?: any,
    endDate?: any,
    shouldExport?: any,
    exportFormat?: any,
  ): Observable<any> {
    const url = `${this.baseUrl}/pan/history`;
    let params = new HttpParams().set('page', page).set('size', size);

    if (searchKey) {
      params = params.set('search_key', searchKey);
    }

    if (searchValue) {
      params = params.set('search_value', searchValue);
    }

    if (startDate) {
      params = params.set('start_date', startDate);
    }

    if (endDate) {
      params = params.set('end_date', endDate);
    }

    if (shouldExport) {
      params = params.set('is_export', shouldExport);
    }

    if (exportFormat) {
      params = params.set('format', exportFormat);
    }

    return this.http.get<any>(url, { params });
  }

  deletePanHistories(searchIds: any): Observable<any> {
    const url = `${this.baseUrl}/pan/delete`;
    const options = {
      body: { pan_search_ids: searchIds },
    };

    return this.http.delete<any>(url, options);
  }

  // GST HISTORY
  getGstHistories(
    page: any,
    size: any,
    searchKey?: any,
    searchValue?: any,
    startDate?: any,
    endDate?: any,
    shouldExport?: any,
    exportFormat?: any,
  ): Observable<any> {
    const url = `${this.baseUrl}/gst/history`;
    let params = new HttpParams().set('page', page).set('size', size);

    if (searchKey) {
      params = params.set('search_key', searchKey);
    }

    if (searchValue) {
      params = params.set('search_value', searchValue);
    }

    if (startDate) {
      params = params.set('start_date', startDate);
    }

    if (endDate) {
      params = params.set('end_date', endDate);
    }

    if (shouldExport) {
      params = params.set('is_export', shouldExport);
    }

    if (exportFormat) {
      params = params.set('format', exportFormat);
    }

    return this.http.get<any>(url, { params });
  }

  exportGstHistories(
    page: any,
    size: any,
    searchKey?: any,
    searchValue?: any,
    startDate?: any,
    endDate?: any,
    shouldExport?: any,
    exportFormat?: any,
  ): Observable<any> {
    return this.getGstHistories(
      page,
      size,
      searchKey,
      searchValue,
      startDate,
      endDate,
      shouldExport,
      exportFormat,
    );
  }

  deleteGstHistories(searchIds: any): Observable<any> {
    const url = `${this.baseUrl}/gst/delete`;
    const options = {
      body: { gst_search_ids: searchIds },
    };

    return this.http.delete<any>(url, options);
  }

  // DIN HISTORY
  getDinHistories(
    page: any,
    size: any,
    searchKey?: any,
    searchValue?: any,
    startDate?: any,
    endDate?: any,
    shouldExport?: any,
    exportFormat?: any,
  ): Observable<any> {
    const url = `${this.baseUrl}/din/history`;
    let params = new HttpParams().set('page', page).set('size', size);

    if (searchKey) {
      params = params.set('search_key', searchKey);
    }

    if (searchValue) {
      params = params.set('search_value', searchValue);
    }

    if (startDate) {
      params = params.set('start_date', startDate);
    }

    if (endDate) {
      params = params.set('end_date', endDate);
    }

    if (shouldExport) {
      params = params.set('is_export', shouldExport);
    }

    if (exportFormat) {
      params = params.set('format', exportFormat);
    }

    return this.http.get<any>(url, { params });
  }

  exportDinHistories(
    page: any,
    size: any,
    searchKey?: any,
    searchValue?: any,
    startDate?: any,
    endDate?: any,
    shouldExport?: any,
    exportFormat?: any,
  ): Observable<any> {
    return this.getDinHistories(
      page,
      size,
      searchKey,
      searchValue,
      startDate,
      endDate,
      shouldExport,
      exportFormat,
    );
  }

  deleteDinHistories(searchIds: any): Observable<any> {
    const url = `${this.baseUrl}/din/delete`;
    const options = {
      body: { din_search_ids: searchIds },
    };

    return this.http.delete<any>(url, options);
  }

  // MOBILE PAN HISTORY
  getMobilePanHistories(
    page: any,
    size: any,
    searchKey?: any,
    searchValue?: any,
    startDate?: any,
    endDate?: any,
    shouldExport?: any,
    exportFormat?: any,
  ): Observable<any> {
    const url = `${this.baseUrl}/mobile-pan/history`;
    let params = new HttpParams().set('page', page).set('size', size);

    if (searchKey) {
      params = params.set('search_key', searchKey);
    }

    if (searchValue) {
      params = params.set('search_value', searchValue);
    }

    if (startDate) {
      params = params.set('start_date', startDate);
    }

    if (endDate) {
      params = params.set('end_date', endDate);
    }

    if (shouldExport) {
      params = params.set('is_export', shouldExport);
    }

    if (exportFormat) {
      params = params.set('format', exportFormat);
    }

    return this.http.get<any>(url, { params });
  }

  exportMobilePanHistories(
    page: any,
    size: any,
    searchKey?: any,
    searchValue?: any,
    startDate?: any,
    endDate?: any,
    shouldExport?: any,
    exportFormat?: any,
  ): Observable<any> {
    return this.getMobilePanHistories(
      page,
      size,
      searchKey,
      searchValue,
      startDate,
      endDate,
      shouldExport,
      exportFormat,
    );
  }

  deleteMobilePanHistories(searchIds: any): Observable<any> {
    const url = `${this.baseUrl}/mobile-pan/delete`;
    const options = {
      body: { mobile_pan_search_ids: searchIds },
    };

    return this.http.delete<any>(url, options);
  }

  // PHONEPE FASTAG HISTORY
  getPhonepeFastagHistories(
    page: any,
    size: any,
    searchKey?: any,
    searchValue?: any,
    startDate?: any,
    endDate?: any,
    shouldExport?: any,
    exportFormat?: any,
  ): Observable<any> {
    const url = `${this.baseUrl}/phonepe-fastag/history`;
    let params = new HttpParams().set('page', page).set('size', size);

    if (searchKey) {
      params = params.set('search_key', searchKey);
    }

    if (searchValue) {
      params = params.set('search_value', searchValue);
    }

    if (startDate) {
      params = params.set('start_date', startDate);
    }

    if (endDate) {
      params = params.set('end_date', endDate);
    }

    if (shouldExport) {
      params = params.set('is_export', shouldExport);
    }

    if (exportFormat) {
      params = params.set('format', exportFormat);
    }

    return this.http.get<any>(url, { params });
  }

  exportPhonepeFastagHistories(
    page: any,
    size: any,
    searchKey?: any,
    searchValue?: any,
    startDate?: any,
    endDate?: any,
    shouldExport?: any,
    exportFormat?: any,
  ): Observable<any> {
    return this.getPhonepeFastagHistories(
      page,
      size,
      searchKey,
      searchValue,
      startDate,
      endDate,
      shouldExport,
      exportFormat,
    );
  }

  deletePhonepeFastagHistories(searchIds: any): Observable<any> {
    const url = `${this.baseUrl}/phonepe-fastag/delete`;
    const options = {
      body: { phonepe_fastag_search_ids: searchIds },
    };

    return this.http.delete<any>(url, options);
  }

  // PHONEPE UPI HISTORY
  getPhonepeUpiHistories(
    page: any,
    size: any,
    searchKey?: any,
    searchValue?: any,
    startDate?: any,
    endDate?: any,
    shouldExport?: any,
    exportFormat?: any,
  ): Observable<any> {
    const url = `${this.baseUrl}/phonepe-upi/history`;
    let params = new HttpParams().set('page', page).set('size', size);

    if (searchKey) {
      params = params.set('search_key', searchKey);
    }

    if (searchValue) {
      params = params.set('search_value', searchValue);
    }

    if (startDate) {
      params = params.set('start_date', startDate);
    }

    if (endDate) {
      params = params.set('end_date', endDate);
    }

    if (shouldExport) {
      params = params.set('is_export', shouldExport);
    }

    if (exportFormat) {
      params = params.set('format', exportFormat);
    }

    return this.http.get<any>(url, { params });
  }

  exportPhonepeUpiHistories(
    page: any,
    size: any,
    searchKey?: any,
    searchValue?: any,
    startDate?: any,
    endDate?: any,
    shouldExport?: any,
    exportFormat?: any,
  ): Observable<any> {
    return this.getPhonepeUpiHistories(
      page,
      size,
      searchKey,
      searchValue,
      startDate,
      endDate,
      shouldExport,
      exportFormat,
    );
  }

  deletePhonepeUpiHistories(searchIds: any): Observable<any> {
    const url = `${this.baseUrl}/phonepe-upi/delete`;
    const options = {
      body: { phonepe_upi_search_ids: searchIds },
    };

    return this.http.delete<any>(url, options);
  }

  // VIRTUAL NUMBER HISTORY
  getVirtualNumberHistories(
    page: any,
    size: any,
    searchKey?: any,
    searchValue?: any,
    startDate?: any,
    endDate?: any,
    shouldExport?: any,
    exportFormat?: any,
  ): Observable<any> {
    const url = `${this.baseUrl}/virtual-number/history`;
    let params = new HttpParams().set('page', page).set('size', size);

    if (searchKey) {
      params = params.set('search_key', searchKey);
    }

    if (searchValue) {
      params = params.set('search_value', searchValue);
    }

    if (startDate) {
      params = params.set('start_date', startDate);
    }

    if (endDate) {
      params = params.set('end_date', endDate);
    }

    if (shouldExport) {
      params = params.set('is_export', shouldExport);
    }

    if (exportFormat) {
      params = params.set('format', exportFormat);
    }

    return this.http.get<any>(url, { params });
  }

  exportVirtualNumberHistories(
    page: any,
    size: any,
    searchKey?: any,
    searchValue?: any,
    startDate?: any,
    endDate?: any,
    shouldExport?: any,
    exportFormat?: any,
  ): Observable<any> {
    const url = `${this.baseUrl}/virtual-number/history`;
    let params = new HttpParams().set('page', page).set('size', size);

    if (searchKey) {
      params = params.set('search_key', searchKey);
    }

    if (searchValue) {
      params = params.set('search_value', searchValue);
    }

    if (startDate) {
      params = params.set('start_date', startDate);
    }

    if (endDate) {
      params = params.set('end_date', endDate);
    }

    if (shouldExport) {
      params = params.set('is_export', shouldExport);
    }

    if (exportFormat) {
      params = params.set('format', exportFormat);
    }

    return this.http.get<any>(url, { params });
  }

  deleteVirtualNumberHistories(searchIds: any): Observable<any> {
    const url = `${this.baseUrl}/virtual-number/delete`;
    const options = {
      body: { virtual_number_search_ids: searchIds },
    };

    return this.http.delete<any>(url, options);
  }

  // ADVANCED SEARCH HISTORY
  getAdvancedSearchHistories(
    page: any,
    size: any,
    searchKey?: any,
    searchValue?: any,
    startDate?: any,
    endDate?: any,
    shouldExport?: any,
    exportFormat?: any,
  ): Observable<any> {
    const url = `${this.baseUrl}/name/history`;
    let params = new HttpParams().set('page', page).set('size', size);

    if (searchKey) {
      params = params.set('search_key', searchKey);
    }

    if (searchValue) {
      params = params.set('search_value', searchValue);
    }

    if (startDate) {
      params = params.set('start_date', startDate);
    }

    if (endDate) {
      params = params.set('end_date', endDate);
    }

    if (shouldExport) {
      params = params.set('is_export', shouldExport);
    }

    if (exportFormat) {
      params = params.set('format', exportFormat);
    }

    return this.http.get<any>(url, { params });
  }

  exportAdvancedSearchHistories(
    page: any,
    size: any,
    searchKey?: any,
    searchValue?: any,
    startDate?: any,
    endDate?: any,
    shouldExport?: any,
    exportFormat?: any,
  ): Observable<any> {
    const url = `${this.baseUrl}/name/history`;
    let params = new HttpParams().set('page', page).set('size', size);

    if (searchKey) {
      params = params.set('search_key', searchKey);
    }

    if (searchValue) {
      params = params.set('search_value', searchValue);
    }

    if (startDate) {
      params = params.set('start_date', startDate);
    }

    if (endDate) {
      params = params.set('end_date', endDate);
    }

    if (shouldExport) {
      params = params.set('is_export', shouldExport);
    }

    if (exportFormat) {
      params = params.set('format', exportFormat);
    }

    return this.http.get<any>(url, { params });
  }

  deleteAdvancedSearchHistories(searchIds: any): Observable<any> {
    const url = `${this.baseUrl}/name/delete`;
    const options = {
      body: { name_search_ids: searchIds },
    };

    return this.http.delete<any>(url, options);
  }

  // BASIC SEARCH HISTORY
  getBasicSearchHistories(
    page: any,
    size: any,
    searchKey?: any,
    searchValue?: any,
    startDate?: any,
    endDate?: any,
    shouldExport?: any,
    exportFormat?: any,
  ): Observable<any> {
    const url = `${this.baseUrl}/basic/history`;
    let params = new HttpParams().set('page', page).set('size', size);

    if (searchKey) {
      params = params.set('search_key', searchKey);
    }

    if (searchValue) {
      params = params.set('search_value', searchValue);
    }

    if (startDate) {
      params = params.set('start_date', startDate);
    }

    if (endDate) {
      params = params.set('end_date', endDate);
    }

    if (shouldExport) {
      params = params.set('is_export', shouldExport);
    }

    if (exportFormat) {
      params = params.set('format', exportFormat);
    }

    return this.http.get<any>(url, { params });
  }

  exportBasicSearchHistories(
    page: any,
    size: any,
    searchKey?: any,
    searchValue?: any,
    startDate?: any,
    endDate?: any,
    shouldExport?: any,
    exportFormat?: any,
  ): Observable<any> {
    return this.getBasicSearchHistories(
      page,
      size,
      searchKey,
      searchValue,
      startDate,
      endDate,
      shouldExport,
      exportFormat,
    );
  }

  deleteBasicSearchHistories(searchIds: any): Observable<any> {
    const url = `${this.baseUrl}/basic/history`;
    const options = {
      body: { basic_search_ids: searchIds },
    };

    return this.http.delete<any>(url, options);
  }

  // WEB SEARCH HISTORY
  getWebSearchHistories(
    page: any,
    size: any,
    searchKey?: any,
    searchValue?: any,
    startDate?: any,
    endDate?: any,
    shouldExport?: any,
    exportFormat?: any,
  ): Observable<any> {
    const url = `${this.baseUrl}/web-capture/history`;
    let params = new HttpParams().set('page', page).set('size', size);

    if (searchKey) {
      params = params.set('search_key', searchKey);
      params = params.set(
        'search_value',
        searchValue || (searchKey === 'created_on' ? '-' : ''),
      );
    }

    if (startDate) {
      params = params.set('start_date', startDate);
    }

    if (endDate) {
      params = params.set('end_date', endDate);
    }

    if (shouldExport) {
      params = params.set('is_export', shouldExport);
    }

    if (exportFormat) {
      params = params.set('format', exportFormat);
    }

    return this.http.get<any>(url, { params });
  }

  exportWebSearchHistories(
    page: any,
    size: any,
    searchKey?: any,
    searchValue?: any,
    startDate?: any,
    endDate?: any,
    shouldExport?: any,
    exportFormat?: any,
  ): Observable<any> {
    return this.getWebSearchHistories(
      page,
      size,
      searchKey,
      searchValue,
      startDate,
      endDate,
      shouldExport,
      exportFormat,
    );
  }

  deleteWebSearchHistories(searchIds: any): Observable<any> {
    const url = `${this.baseUrl}/web-capture/delete`;
    const options = {
      body: { web_capture_ids: searchIds },
    };

    return this.http.delete<any>(url, options);
  }

  // FACE COMPARE HISTORY
  getFaceCompareHistories(
    page: any,
    size: any,
    searchKey?: any,
    searchValue?: any,
    startDate?: any,
    endDate?: any,
  ): Observable<any> {
    const url = `${this.baseUrl}/face-compare/history`;
    let params = new HttpParams().set('page', page).set('size', size);

    if (searchKey) {
      params = params.set('search_key', searchKey);
    }

    if (searchValue) {
      params = params.set('search_value', searchValue);
    }

    if (startDate) {
      params = params.set('start_date', startDate);
    }

    if (endDate) {
      params = params.set('end_date', endDate);
    }

    return this.http.get<any>(url, { params });
  }

  deleteFaceCompareHistories(faceCompareIds: any): Observable<any> {
    const url = `${this.baseUrl}/face-compare/history`;
    const options = {
      body: { face_compare_ids: faceCompareIds },
    };

    return this.http.delete<any>(url, options);
  }

  getFaceCompareResults(
    faceCompareId: any,
    page: any = 1,
    size: any = 10,
  ): Observable<any> {
    const url = `${this.baseUrl}/face-compare/results`;
    const params = new HttpParams()
      .set('face_compare_id', faceCompareId)
      .set('page', page)
      .set('size', size);

    return this.http.get<any>(url, { params });
  }

  updateFaceCompareNotes(faceCompareId: any, notes: string): Observable<any> {
    const url = `${this.baseUrl}/face-compare/notes/${faceCompareId}`;
    return this.http.put<any>(url, { notes: notes ?? '' });
  }

  // VIDEO SCANNER HISTORY
  getVideoScannerHistories(
    page: any,
    size: any,
    searchKey?: any,
    searchValue?: any,
    startDate?: any,
    endDate?: any,
  ): Observable<any> {
    const url = `${this.baseUrl}/video-scanner/history`;
    let params = new HttpParams().set('page', page).set('size', size);

    if (searchKey) {
      params = params.set('search_key', searchKey);
    }

    if (searchValue) {
      params = params.set('search_value', searchValue);
    }

    if (startDate) {
      params = params.set('start_date', startDate);
    }

    if (endDate) {
      params = params.set('end_date', endDate);
    }

    return this.http.get<any>(url, { params });
  }

  deleteVideoScannerHistories(videoScannerIds: any): Observable<any> {
    const url = `${this.baseUrl}/video-scanner/history`;
    const options = {
      body: { video_scanner_ids: videoScannerIds },
    };

    return this.http.delete<any>(url, options);
  }

  getVideoScannerFrames(
    videoScannerId: any,
    page: any = 1,
    size: any = 100,
  ): Observable<any> {
    const url = `${this.baseUrl}/video-scanner/frames`;
    const params = new HttpParams()
      .set('video_scanner_id', videoScannerId)
      .set('page', page)
      .set('size', size);

    return this.http.get<any>(url, { params });
  }
}
